import { call, takeLatest } from "redux-saga/effects";
import axiosInstance from "../../redux/axiosInstance";
import ENV from "../config/env";
import { store } from "../store";

import {
  USER_LIST_REQUEST,
  USER_ADD_REQUEST,
  USER_GET_REQUEST,
  USER_ACTIVE_DEACTIVE_REQUEST,
} from "./userManagement.types";

function getErrorMessage(error) {
  return (
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error.message ||
    "Something went wrong"
  );
}

function* userListSaga(action) {
  const { payload, callback } = action;
  // payload shape: { page, size, filters: { active: [true/false], ... }, sort: { ... } }
  try { 
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.USER_SERVICE_URL}/listing/Users`,
      
      payload
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* userAddSaga(action) {
  const { payload, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.USER_SERVICE_URL}/add/User`,
      payload
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* userGetSaga(action) {
  const {
    payload: { userId },
    callback,
  } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.USER_SERVICE_URL}/get/User/Details/ById/ForStaffManagement?id=3`
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* userActiveDeactiveSaga(action) {
  const { payload, callback } = action;
  try {
    const { data } = yield call(axiosInstance.post, payload.endPoint);
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

export function* userManagementWatcherSaga() {
  yield takeLatest(USER_LIST_REQUEST, userListSaga);
  yield takeLatest(USER_ADD_REQUEST, userAddSaga);
  yield takeLatest(USER_GET_REQUEST, userGetSaga);
  yield takeLatest(USER_ACTIVE_DEACTIVE_REQUEST, userActiveDeactiveSaga);
}
